import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { SYSTEM_INFO_TAB_PLUGIN } from '@mp/system/info/system-info-tab-plugin/util';

import { createContentManagerRecurringJobsTabPlugin } from './create-content-manager-recurring-jobs-tab-plugin';

/**
 * Registriert den Content-Management-RecurringJobs-Tab auf der `/system/info`-Seite.
 */
export function provideContentManagerRecurringJobsTabPlugin(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SYSTEM_INFO_TAB_PLUGIN,
      multi: true,
      useFactory: createContentManagerRecurringJobsTabPlugin,
    },
  ]);
}
